module.exports = __webpack_public_path__ + "static/img/mcs_story.1ceaa1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/mcs_story.jpg
// module id = bZp+
// module chunks = 3